import { tenantType, tenantTypeCap } from "./constant"

var tenantTypeId = JSON.parse(localStorage.getItem('tenantTypeId'));

export const RESOURCES = {
    View_Contact_Details: `View ${tenantTypeCap[tenantTypeId]} Details`,
    View_License_Details: `View License Details`,
    View_Appointment_Details: `View Appointment Details`,
    View_RegulatoryAction_Details: `View Regulatory Action Details`,

  }
